module.exports = require('./lib/axios');


//////////////////
// WEBPACK FOOTER
// ./~/axios/index.js
// module id = 129
// module chunks = 1